/**
 * takes an object and encodes it as a uri component
 * @param data
 */
export const encodeAsFormUrlencoded = (data) => Object.entries(data).map(([key, value]) => `${key}=${encodeURIComponent(value)}`).join("&")




// WEBPACK FOOTER //
// ./node_modules/mb-app-common/lib/util/api.js